import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import {InputField} from "../../Shared/InputField"

const calcDue = (qty, price) => {
    const result = qty * price
    return result % 1 === 0 ? result : Math.round(result * 100) / 100
}

const BuySmsForm = () => {
    const [errors, setErrors] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)

    const [formData, setFormData] = useState({
        payment_number: "",
        quantity: 0,
        min: 0,
        max: 0,
        price: 0,
        due: 0
    })
    const {payment_number, quantity, min, max, price, due} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (!location.state) {
            navigate('/messages/balance')
            return
        }
        const {data} = location.state
        setFormData((prev) => ({
            ...prev,
            min: data.min,
            max: data.max,
            price: data.price,
            quantity: data.min,
            due: calcDue(data.min, data.price)
        }))
    } ,[])

    const onChange = (e) => {
        const { name, value } = e.target
        if (name === 'quantity') {
            const qty = parseInt(value, 10) || 0
            setFormData((prev) => ({
                ...prev,
                quantity: qty,
                due: calcDue(qty, prev.price),
            }))
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }))
        }
    }

    const handleBlur = (e) => {
        if (e.target.name === 'quantity') {
            const clamped = Math.min(Math.max(parseInt(e.target.value, 10) || min, min), max)
            setFormData((prev) => ({
                ...prev,
                quantity: clamped,
                due: calcDue(clamped, prev.price),
            }))
        }
    };

    const onSubmit = (e) => {
        e.preventDefault()

        const qty = parseInt(quantity, 10) || 0
        if (qty < min || qty > max) {
            setErrors((prev) => ({
                ...prev,
                quantity: `Quantity must be between ${min} and ${max}`
            }))
            return
        }

        const payload = {
            price: price,
            payment_number: payment_number,
            quantity: qty,
        }
        buyMessages(payload)
    }

    const buyMessages = async (payload) => {
        setIsSubmitting(true)
        try {
            const response = await Server.post('/messages/buy', payload)
            if (response.status === 201){
                toast.success(response.data?.detail)
                navigate('/messages/balance')
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            if(error?.response?.status === 401){
                navigate('/login')
            }else if (error?.response?.status === 422) {
                const validationErrors = {}
                error.response?.data?.detail.forEach((err) => {
                    validationErrors[err.loc[1]] = err.msg
                })
                setErrors(validationErrors)
            }else if (error?.response?.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to buy SMS')
            }
        } finally {
            setIsSubmitting(false)
        }
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Buy SMS Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder={min.toString()}
                                name="quantity"
                                type="number"
                                label="Number of Messages"
                                info={`Min: ${min} — Max: ${max}`}
                                value={quantity}
                                min={min}
                                max={max}
                                onChange={onChange}
                                onBlur={handleBlur}
                                error={errors.quantity}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="price"
                                type="number"
                                disabled="disabled"
                                label="Price"
                                value={price}
                                onChange={onChange}
                                error={errors.price}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="due"
                                type="number"
                                disabled="disabled"
                                label="Due Amount"
                                value={due}
                                onChange={onChange}
                                error={errors.due}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="e.g 618304530"
                                name="payment_number"
                                type="text"
                                label="Payment Number"
                                value={payment_number}
                                onChange={onChange}
                                error={errors.payment_number}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <button
                                type="submit"
                                className="btn btn-outline-info"
                                style={{float: 'right'}}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Processing…' : 'Continue Checkout Process'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default BuySmsForm
